import { CurrentUserDto } from 'models/dtoTypes';
import SmeConfig from 'data/SmeConfig';

interface ClearSession {
  (): void;
}

interface GetCompanyName {
  (): string;
}

interface SetUser {
  (companyJsonString: string): void;
}

interface IsValid {
  (aadUserId?: string): boolean;
}

interface Refresh {
  (config: SmeConfig): Promise<CurrentUserDto | undefined>;
}

interface GetProperty {
  (field: string): string;
}

interface GetRole {
  (): string | undefined;
}

interface GetAadUserId {
  (): string;
}

interface GetOrganisationId {
  (): string;
}

interface SetRole {
  (role: string): void;
}

interface GetLocale {
  (): string;
}

interface SetLocale {
  (locale: string): void;
}

// TODO: remove getLocale, use getScope('locale') instead
interface GetScope {
  (scope: string): string;
}

interface SetScope {
  (scope: string, value: string): void;
}

export enum EFeature {
  user = 'user',
  organisation = 'organisation',
  companyList = 'companyList',
  scoreCompany = 'scoreCompany',
  smartGovernance = 'acceptSmartGovernance',
  assignSg = 'assignSg',
}

interface Authentication {
  // delete all local storage after logout
  clearSession: ClearSession;
  getCompanyName: GetCompanyName;
  // pass keyName, get current user.company[keyName]
  getCompanyAttr: GetProperty;
  getOrganisationAttr: GetProperty;

  // save user jsonstring to local storage
  setUser: SetUser;
  // get user.aadUserId
  getAadUserId: GetAadUserId;
  getOrganisationId: GetOrganisationId;
  getRole: GetRole;
  setRole: SetRole;
  getLocale: GetLocale;
  setLocale: SetLocale;
  // scope: user's preference, e.g. selected country code
  getScope: GetScope;
  setScope: SetScope;

  // pass in aadUserId as params, if aadUserId changed or currentUserCachedAt was 2 hours ago, it is invalid
  isValid: IsValid;

  // force GetCurrentUser via api and refresh local storage
  refresh: Refresh;

  // AppResource
  isAdmin: () => boolean;
  canManageResource: (resource: EFeature) => boolean;
}

export default Authentication;
